import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import '../../../styles/LtsDatePicker.css';
import { getCurrentWeekDates } from '../utils/ltsCardDetailsUtils';
import { getLtsStationDetails } from '../utils/LtsUtils';
import { LiveTrainStatusContext } from '../LiveTrainStatus';
import * as liveTrainStatusActions from '../../../actions/liveTrainStatusActions';
import { formatDateForLtsApiRequest } from '../utils/commonLtsUtils';
import { trackClickEventLTS } from '../../../utils/omnitureUtils';
import { DATE_CLICKED } from '../constants/LtsTrackingConstants';
import { PROP_62 } from '../../../utils/omnitureUtilConstants';

const LtsDatePicker = ({ customClass }) => {
  const {
    ltsPageState: { trainNumber, trainStartDate = formatDateForLtsApiRequest(new Date()), daysOfRun } = {},
    ltsPageDispatch
  } = useContext(LiveTrainStatusContext);

  const datePickerOptions = getCurrentWeekDates(daysOfRun);

  const initialSelectedDateIndex = datePickerOptions.findIndex((day) =>
    trainStartDate.includes(formatDateForLtsApiRequest(day.date))
  );
  const [selectedDateIndex, setSelectedDateIndex] = useState(initialSelectedDateIndex);

  const handleClick = async (index) => {
    trackClickEventLTS(DATE_CLICKED, PROP_62);
    ltsPageDispatch({
      type: liveTrainStatusActions.ACTION_LTS_FETCH_START
    });
    const ltsResponseClientSide = await getLtsStationDetails({
      trainNumber,
      trainStartDate: formatDateForLtsApiRequest(datePickerOptions[index].date)
    });
    ltsPageDispatch({
      type: liveTrainStatusActions.ACTION_UPDATE_LTS_STATION_DETAILS,
      data: ltsResponseClientSide
    });
    setSelectedDateIndex(index);
  };

  return (
    <div className={`${customClass} ltsDatePicker`}>
      <ul>
        {datePickerOptions &&
          datePickerOptions.map((item, index) => {
            const { formattedString, weekDay } = item;
            return (
              <li
                onClick={() => {
                  if (item.isActive) {
                    handleClick(index);
                  }
                }}
                className={[
                  `${item.isActive ? '' : 'notRunningToday'}`,
                  `${selectedDateIndex === index ? 'selected' : ''}`
                ]
                  .join(' ')
                  .trim()}
                title={!item.isActive ? 'Train does not run on this day' : ''}
                key={index}
              >
                <span className="weekDay">{weekDay}</span>
                <span className="date">{formattedString}</span>
              </li>
            );
          })}
      </ul>
    </div>
  );
};

LtsDatePicker.propTypes = {
  customClass: PropTypes.string
};

export default LtsDatePicker;
